// removed by extract-text-webpack-plugin
module.exports = {"message":"RedirectedMessage-style__message__jg-QG"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/RedirectedMessage/RedirectedMessage-style.scss
// module id = 3057
// module chunks = 4